import { render, staticRenderFns } from "./TheMainHeader.vue?vue&type=template&id=5e83147c&"
import script from "./TheMainHeader.vue?vue&type=script&lang=js&"
export * from "./TheMainHeader.vue?vue&type=script&lang=js&"
import style0 from "./TheMainHeader.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e83147c')) {
      api.createRecord('5e83147c', component.options)
    } else {
      api.reload('5e83147c', component.options)
    }
    module.hot.accept("./TheMainHeader.vue?vue&type=template&id=5e83147c&", function () {
      api.rerender('5e83147c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/TheMainHeader.vue"
export default component.exports